import { EXT_ADDRESS_URL } from 'src/config/api.config';
import AppConfig from 'src/flavours/index.flavour';
import { doGet } from 'src/utils/apiCallers';

class AddressService {
  get = (params) => {
    return doGet(EXT_ADDRESS_URL, params, {
      Authorization: `Bearer ${AppConfig.locationApiKey}`
    });
  };
}

export default new AddressService();
